import './Dots.scss';

export const Dots = () => <div className="dot-flashing"></div>;
export default Dots;
